
const actionNameGenerator = (domainPrefix) => {
    return (actionType) => `${domainPrefix}/${actionType}`;
  };

const domainPrefix = "glo";

const gloActionNameGenerator = actionNameGenerator(domainPrefix);

export const accountChangeType = gloActionNameGenerator("accountChange");
export const accountDataRequestFailedType = gloActionNameGenerator("accountDataRequestFailed");
export const accountChangeAfterOAAType = gloActionNameGenerator("accountChangeAfterOAA");
export const accountDetailsDataSuccessType = gloActionNameGenerator("accountDetailsDataSuccess");
export const accountDetailsDataSuccessLoaderType = gloActionNameGenerator("accountDetailsDataSuccessLoader");
export const accountDataReceivedType = gloActionNameGenerator("accountDataReceived");
export const accountDetailsDataFailedType = gloActionNameGenerator("accountDetailsDataFailed");
export const changeAccountStatusType = gloActionNameGenerator("changeAccountStatus");
export const clearGlobalErrorType = gloActionNameGenerator("clearGlobalError");
export const CSRDataSuccessType = gloActionNameGenerator("CSRDataSuccess");
export const CSRDataFailedType = gloActionNameGenerator("CSRDataFailed");
export const decrementTimerType = gloActionNameGenerator("decrementTimer");
export const editStepperIndexType = gloActionNameGenerator("editStepperIndex");
export const exitExchangeType = gloActionNameGenerator("exitExchange");
export const fetchSummaryType = gloActionNameGenerator("fetchSummary");
export const fetchAccountDataType = gloActionNameGenerator("fetchAccountData");
export const fetchAccountAdvisorsType = gloActionNameGenerator("fetchAccountAdvisors");
export const fetchAccountDetailsDataType = gloActionNameGenerator("fetchAccountDetailsData");
export const fetchCodeValueMappingType = gloActionNameGenerator("fetchCodeValueMapping");
export const handleServerError = gloActionNameGenerator("handleServerError");
export const fetchAccountAdvisorsSuccessType = gloActionNameGenerator("fetchAccountAdvisorsSuccess");
export const fetchAccountAdvisorsFailedType = gloActionNameGenerator("fetchAccountAdvisorsFailed");
export const globalSetAccountDataLoadingType = gloActionNameGenerator("globalSetAccountDataLoading");
export const getCSRDataType = gloActionNameGenerator("getCSRData");
export const getAvailableBalanceType = gloActionNameGenerator("getAvailableBalance");
export const getBusinessFunctionForCSRType = gloActionNameGenerator("getBusinessFunctionForCSR");
export const getAvailableBalanceWorkerSuccessType = gloActionNameGenerator("getAvailableBalanceWorkerSuccess");
export const getCodeValueMappingSucessType = gloActionNameGenerator("getCodeValueMappingSucess");
export const getCodeValueMappingFailedType = gloActionNameGenerator("getCodeValueMappingFailed");
export const getUserDetailsType = gloActionNameGenerator("getUserDetails");
export const getDropdownValuesType = gloActionNameGenerator("getDropdownValues");
export const getAPIDataType = gloActionNameGenerator("getAPIData");
export const getUserEditDetailsType = gloActionNameGenerator("getUserEditDetails");
export const getAvailableBalanceWorkerFailedType = gloActionNameGenerator("getAvailableBalanceWorkerFailed");
export const globalAccountDataLoadType = gloActionNameGenerator("globalAccountDataLoad");
export const hidePopupType = gloActionNameGenerator("hidePopup");
export const headerDataType = gloActionNameGenerator("headerData");
export const logoutSessionFlushType = gloActionNameGenerator("logoutSessionFlush");
export const modifyStepperConfigType = gloActionNameGenerator("modifyStepperConfig");
export const hideErrorModalType = gloActionNameGenerator("hideErrorModal");
export const motherOfAllErrorsType = gloActionNameGenerator("motherOfAllErrors");
export const makeRecommendFromPoolsType = gloActionNameGenerator("makeRecommendFromPools");
export const postCoachMarksType = gloActionNameGenerator("postCoachMarks");
export const primaryAccountChangedType = gloActionNameGenerator("primaryAccountChanged");
export const resetStepperStateType = gloActionNameGenerator("resetStepperState");
export const recommendAnExchangeDataSuccessType = gloActionNameGenerator("recommendAnExchangeDataSuccess");
export const showPopupType = gloActionNameGenerator("showPopup");
export const setUserSessionSuccessType = gloActionNameGenerator("setUserSessionSuccess");
export const summaryDataSuccessType = gloActionNameGenerator("summaryDataSuccess");
export const summaryDataErrorType = gloActionNameGenerator("summaryDataError");
export const setCSRBusinessFunctionItemsType = gloActionNameGenerator("setCSRBusinessFunctionItems");
export const updateActiveFlowType = gloActionNameGenerator("updateActiveFlow");
export const updateActivePageType = gloActionNameGenerator("updateActivePage");
export const updateActivePageStepNumberType = gloActionNameGenerator("updateActivePageStepNumber");
export const updateStepperConfigType = gloActionNameGenerator("updateStepperConfig");
export const updatePageSteptoFinishType = gloActionNameGenerator("updatePageSteptoFinish");
export const updatePageStepToProcessType = gloActionNameGenerator("updatePageStepToProcess");
export const updateStepperIndexType = gloActionNameGenerator("updateStepperIndex");
export const updateStepperAllToFinishType = gloActionNameGenerator("updateStepperAllToFinish");

export const pullBusinessFunctionForCsrType = gloActionNameGenerator("pullBusinessFunctionForCsr");
export const csrBusinessFunctionSuccessType  = gloActionNameGenerator("csrBusinessFunctionSuccess");
export const csrBusinessFunctionFailedType  = gloActionNameGenerator("csrBusinessFunctionFailed");
export const makeUserSessionSuccessType = gloActionNameGenerator("makeUserSessionSuccess");
export const fetchUserInfoType = gloActionNameGenerator("fetchUserInfo");
export const fetchUserSuccessType = gloActionNameGenerator("fetchUserInfoSuccess");
export const fetchUserInfoFailureType = gloActionNameGenerator("fetchUserInfoFailure");
export const fetchDropDownValType = gloActionNameGenerator("fetchDropdownValues");
export const fetchRelationDropDownSuccessType = gloActionNameGenerator("fetchRelationDropdownValSuccess");
export const fetchRelationDropDownFailureType = gloActionNameGenerator("fetchRelationDropdownValFailure");